/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * The reducer for Guard module
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.11.4
 * @since 1.0.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import { GuardActionType } from '../actions/guardActions';
import { CHECK_GUARD_ERROR, CHECK_GUARD_SUCCESSFUL, SET_GUARD_COMPONENT_KEY } from '../constants/actionConstants';
import { AccessComponentKeyEnum, initialGuardState } from '../constants/guard/guardConstants';

export type guardComponentType = { [K in AccessComponentKeyEnum]: boolean };

export interface IGuardReducer {
    components: guardComponentType;
    error: string;
    isLoaded: boolean;
}

const guardReducer: Reducer<IGuardReducer, GuardActionType> = (state = initialGuardState, action: GuardActionType) =>
    produce(state, draft => {
        switch (action.type) {
            case CHECK_GUARD_SUCCESSFUL:
                draft.components = action.payload.components;
                draft.isLoaded = true;
                break;
            case CHECK_GUARD_ERROR:
                draft.error = action.payload.error;
                draft.isLoaded = true;
                break;
            case SET_GUARD_COMPONENT_KEY:
                draft.components[action.payload.componentKey] = action.payload.isEnabled;
                break;
            default:
                break;
        }
    });

export default guardReducer;
